import { darkBackgroundBlur } from '@repo/ui/components/utilities';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { layoutConstants } from 'styles/layoutConstants';
import { FlexColumn, FlexRow } from 'styles/layouts';

export const OuterMobileWrapper = styled(FlexColumn)<{ hasBanner: boolean }>`
  z-index: ${themeStyle.zIndexS2};
  top: ${({ hasBanner }) => (hasBanner ? 'var(--banner-height)' : '0px')};
  position: fixed;
  width: 100%;
`;

export const MobileWrapper = styled(FlexRow)`
  box-sizing: border-box;
  width: 100%;
  height: ${layoutConstants.mobileHeaderHeight};
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  transition: background 0.3s;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12);
  background: ${themeStyle.varBackgroundAlt};

  ${darkBackgroundBlur}
`;

export const LogoContainer = styled(FlexRow)`
  flex: 1;
  height: 100%;
  width: 100%;
  padding-left: 0px;
  align-items: center;
  justify-content: unset;
  transition:
    opacity 250ms,
    transform 250ms linear;

  ${QUERIES.tabletAndUp} {
    padding-left: 54px;
    justify-content: center;
  }
`;

export const RightWrapper = styled.div`
  padding-left: 15px;
`;

export const HamburgerButtonWrapper = styled(FlexRow)`
  justify-content: flex-start;
  align-items: center;
  height: 100%;
`;

export const HamburgerButton = styled.button`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  background: transparent;
  border: none;
  padding-right: 0px;

  ${QUERIES.tabletAndUp} {
    padding-right: 11px;
  }
`;
